import { $success } from 'constants/styles/_colors';

// viewport width
export const sideNavWidth = 66;
export const subNavWidth = 250;

export const defaultStyleLayer = 'light';
export const rightPanelContainerWidth = 660;
export const targetViewportWidth = 1024;
export const minMapViewport = targetViewportWidth - (sideNavWidth + rightPanelContainerWidth);

export const stepIcon = {
	fontSize: '18px',
	border: `3px solid ${$success}`,
	borderRadius: '50%',
	textAlign: 'center',
	height: '38px',
	width: '38px',
	lineHeight: '33px',
	fontWeight: 700
};

export const createEditDrawerStyles = {
	tabRoot: {
		textTransform: 'none'
	},
	swipeableStyle: {
		flexGrow: 1,
		overflowY: 'auto'
	},
	swipeableContainerStyle: {
		height: '100%'
	},
	bottom: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		flex: 1
	},
	drawerContainer: {
		display: 'flex',
		flexFlow: 'column',
		height: '100%',
		overflowY: 'hidden'
	},
	drawerFixedTop: {
		flex: '0 1 auto'
	},
	drawerScrollableBottom: {
		flex: '1 1 auto',
		overflowY: 'auto'
	},
	topDetails: {
		marginTop: '20px',
		marginBottom: '40px'
	},
	listItemsPresent: {
		marginTop: '20px',
		padding: '0px'
	},
	noListItemsPresent: {
		padding: '0px'
	},
	statusPlaceholder: {
		height: '27px'
	},
	buttonsSection: {
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
		marginBottom: '20px'
	},
	mobileButtonsSection: {
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginBottom: '20px'
	},
	editModeActions: {
		display: 'flex',
		alignItems: 'center'
	},
	exitEditMode: {
		textTransform: 'none',
		marginRight: '10px'
	},
	addBtnContainer: {
		position: 'relative'
	},
	requiredNote: {
		position: 'absolute',
		bottom: '-20px',
		width: '100%',
		textAlign: 'center',
		fontSize: '12px',
		fontStyle: 'italic'
	},
	statusSelector: {
		marginRight: '10px'
	},
	fullWidth: {
		width: '100%'
	},
	fullHeightPanel: {
		height: '100%'
	},
	fullHeight: {
		height: '100%'
	},
	title: {
		fontWeight: 700,
		marginBottom: '20px'
	},
	titleNoMargin: {
		fontWeight: 700
	},
	section: {
		marginBottom: '40px'
	},
	checkboxLabel: {
		fontSize: '18px',
		lineHeight: '42px',
		verticalAlign: 'middle'
	},
	card: {
		padding: '20px'
	},
	headerContainer: {
		display: 'grid',
		gridTemplateColumns: '5fr 2fr',
		gap: '40px',
		alignItems: 'center'
	},
	inline: {
		display: 'flex',
		justifyContent: 'space-between'
	},
	columnsContainer: {
		height: '100%',
		display: 'flex',
		gap: '0 40px'
	},
	column: {
		display: 'flex',
		flexDirection: 'column',
		width: 'calc(50% - 20px)'
	},
	input: {
		'&::placeholder': {
			fontSize: '24px',
			lineHeight: '26px'
		}
	},
	field: {
		marginTop: '20px'
	},
	fieldContainer: {
		margin: '20px 0'
	},
	autoFitColumns: {
		display: 'grid',
		// gap: 6,
		columnGap: '48px',
		rowGap: '0px',
		gridTemplateColumns: 'repeat(auto-fit, minmax(325px, 1fr))'
	}
};

export const actionHeaderStyles = {
	actionsHeader: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		minHeight: '81px'
	},
	top: {
		display: 'flex',
		// flex: '1 1 0%',
		flexDirection: 'row',
		alignItems: 'center',
		marginBottom: '20px',
		gridTemplateColumns: 'auto 1fr auto',
		gridGap: '15px'
	},
	mobileTop: {
		display: 'flex',
		flex: '1 1 0%',
		flexDirection: 'row',
		alignItems: 'center',
		marginBottom: '10px',
		gridGap: '15px'
	},
	titleAndNavButton: {
		flex: '1 1 auto',
		flexGrow: 2
	},
	bottom: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		gap: '20px'
	},
	mainButton: {
		float: 'right',
		marginRight: '15px',
		width: 'fit-content'
	},
	searchInput: {
		width: '250px'
	},
	zoomToSelectedButton: {
		textTransform: 'none'
	},
	buttonRow: {
		display: 'flex',
		gap: '0 10px'
	}
};

export const filterStyles = {
	filterButton: {
		textTransform: 'none',
		width: '100%'
	},
	popoverContainer: {
		display: 'flex',
		flexDirection: 'column'
	},
	popoverContent: {
		padding: '20px',
		paddingBottom: '20px'
	},
	clearIcon: {
		fontSize: '12px'
	},
	mobileAppliedFilters: {
		marginBottom: '20px'
	},
	cardActions: {
		paddingTop: '0 !important'
	},

	noOptions: {
		padding: '20px'
	}
};

export const fabStyles = {
	fabContainer: {
		backgroundColor: 'common.white',
		height: '40px',
		width: '40px',
		boxShadow: 2
	}
};

export const authenticationPagesStyles = {
	main: {
		height: '100%',
		width: '100%',
		overflow: 'auto',
		padding: {
			xs: '30px',
			xl: '40px'
		},
		backgroundColor: 'background.default',
		display: 'flex',
		flexDirection: 'column',
		// alignItems: 'stretch',
		justifyContent: 'space-between',
		// [theme.breakpoints.down('lg')]: {
		// 	alignItems: 'center',
		// 	padding: '30px'
		// },
		alignItems: {
			xs: 'center', // applies up to and including lg
			xl: 'stretch' // applies at xl and up
		}
	},
	headerContainer: {
		display: 'flex',
		width: '100%',
		alignItems: 'center',
		justifyContent: 'space-between',
		flexDirection: {
			xs: 'column',
			xl: 'row'
		},
		gap: {
			xs: '20px',
			xl: 0
		},
		marginBottom: {
			xs: '20px',
			xl: 0
		}
	},
	logo: {
		cursor: 'pointer'
	},
	airControlLogo: {
		marginBottom: '20px',
		maxWidth: '400px',
		width: {
			xs: '100%',
			sm: 'auto'
		}
	},
	outlineButton: {
		fontWeight: 'bold',
		height: '50px',
		width: '350px',
		maxWidth: '100%'
	},
	topSupportButton: {
		display: {
			xs: 'none',
			lg: 'block'
		}
	},
	bottomSupportButton: {
		marginTop: '20px',
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	mainContainer: {
		width: '1200px',
		margin: {
			xs: '0 auto 50px',
			xl: '50px auto'
		},
		maxWidth: '100%'
	},
	leftContainer: {
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'column'
	},
	leftContainerText: {
		fontWeight: 800,
		display: 'flex',
		flexDirection: 'column',
		alignItems: {
			xs: 'center',
			xl: 'flex-start'
		}
	},
	rightContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: {
			xs: 'center',
			xl: 'flex-start'
		}
	},
	outlineContainer: {
		display: 'flex',
		flexDirection: 'column',
		padding: {
			xs: '20px',
			xl: '50px'
		},
		width: {
			xs: '100%',
			xl: '500px'
		},
		border: '1px solid',
		borderColor: 'grey.500',
		borderRadius: '4px',
		maxWidth: {
			xs: '500px',
			xl: 'none'
		}
	},
	inviteName: {
		fontSize: '30px'
	},
	accountName: {
		fontSize: '30px',
		fontWeight: 'bold',
		color: 'primary.main',
		marginRight: '10px',
		marginLeft: '10px'
	},
	welcome: {
		fontSize: '50px',
		marginBottom: '15px',
		display: 'block'
	},
	belowAirControl: {
		marginTop: '40px',
		'& > div:first-child': {
			marginBottom: '10px'
		},
		display: {
			xs: 'none',
			lg: 'block'
		}
	},
	actionLink: {
		fontWeight: 'bold',
		cursor: 'pointer',
		color: 'primary.main'
	},
	belowSignIn: {
		display: {
			xs: 'flex',
			lg: 'none'
		},
		flexDirection: 'column',
		alignItems: 'center',
		paddingLeft: '20px',
		paddingRight: '20px',
		width: '100%',
		maxWidth: '700px',
		'& .MuiTypography-root': {
			fontWeight: 'bold',
			marginTop: '30px'
		}
	},
	formTitle: {
		fontSize: '30px',
		marginBottom: '30px'
	},
	textFieldNoMargin: {
		borderRadius: '3px'
	},
	textField: {
		borderRadius: '3px',
		marginTop: '30px'
	},
	authCopy: {
		lineHeight: '1.5em',
		width: '500px',
		maxWidth: '100%',
		fontSize: '18px',
		fontWeight: 'bold',
		marginTop: '30px',
		display: {
			xs: 'none',
			lg: 'block'
		}
	},
	button: {
		marginTop: '30px',
		height: '50px'
	},
	error: {
		display: 'flex',
		justifyContent: 'center',
		textAlign: 'center',
		backgroundColor: 'error.main',
		padding: '5px',
		width: '100%',
		maxWidth: '500px',
		marginBottom: '5px',
		marginTop: '5px'
	},
	appLinks: {
		display: 'grid',
		gridGap: '40px',
		gridTemplateColumns: '1fr 1fr'
	},
	divider: {
		borderColor: 'text.secondary',
		marginTop: '30px',
		marginBottom: '30px',
		width: '100%'
	},
	download: {
		fontSize: '20px',
		marginTop: '20px',
		marginBottom: '20px',
		textAlign: 'center'
	},
	forgotPassword: {
		alignSelf: 'flex-end',
		marginTop: '20px',
		cursor: 'pointer'
	},
	termsCheckbox: {
		marginTop: '30px'
	},
	checkboxContainer: {
		display: 'flex',
		alignItems: 'center'
	},
	or: {
		marginTop: '30px'
	}
};

export const viewDrawerStyles = {
	container: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%'
	},
	bottom: {
		display: 'flex',
		flexDirection: 'column',
		flex: 1
	},
	tabRoot: {
		textTransform: 'none'
	},
	fullHeightPanel: {
		height: '100%'
	},
	swipeableStyle: {
		flexGrow: 1,
		overflowY: 'auto'
	},
	swipeableContainerStyle: {
		height: '100%'
	},
	section: {
		marginBottom: '40px'
	},
	card: {
		flexShrink: 0,
		padding: '0 40px 0 20px'
	},
	cardActions: {
		justifyContent: 'flex-end'
	}
};

export const dataGridStyle = {
	backgroundColor: 'background.default',
	border: 'none !important',
	'& .MuiDataGrid-columnHeader': {
		justifyContent: 'flex-end',
		'&:focus-within': {
			outline: 'none !important'
		},
		'& .MuiDataGrid-columnHeaderTitle': {
			fontSize: '15px',
			fontWeight: 600,
			color: 'text.secondary'
		}
	},
	'& .MuiDataGrid-cell': {
		fontSize: '15px',
		'&:focus-within': {
			outline: 'none !important'
		},
		display: 'flex',
		alignItems: 'center'
	},
	' & .MuiDataGrid-pinnedColumns': {
		backgroundColor: 'grey.50'
	},
	' & .MuiDataGrid-pinnedColumnHeaders': {
		backgroundColor: 'grey.50'
	},
	'& .no-top-border': {
		borderBottom: 'none !important'
	},
	'& .no-bottom-border': {
		borderTop: 'none !important'
	},
	'& .selected-row': {
		backgroundColor: `blue.50 !important`
	},
	'& .sticky-row': {
		position: 'sticky',
		bottom: 0,
		backgroundColor: 'background.default',
		borderTop: '1px solid rgba(224, 224, 224, 1)'
	},
	'& .MuiDataGrid-pinnedRows > .MuiDataGrid-row': {
		backgroundColor: `primary.main !important`, // Example styling for pinned rows
		'&:hover': {
			cursor: 'default'
		}
	}
};
